/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Shared_Behaviour_LockedInputs */



/**
* | output |
* | --- |
* | "This agent is shared, so only an admin can change what it does — its instructions, abilities, knowledge, model or limits. You can still rename it, or make it..." |
*
* @param {Agent_Builder_Shared_Behaviour_LockedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_shared_behaviour_locked = /** @type {((inputs?: Agent_Builder_Shared_Behaviour_LockedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Shared_Behaviour_LockedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Agent ist geteilt, daher kann nur eine Administratorin oder ein Administrator ändern, was er tut — Anweisungen, Fähigkeiten, Wissen, Modell oder Grenzen. Sie können ihn weiterhin umbenennen oder privat schalten, um ihn selbst zu bearbeiten.")
	return /** @type {LocalizedString} */ ("This agent is shared, so only an admin can change what it does — its instructions, abilities, knowledge, model or limits. You can still rename it, or make it private to edit it on your own.")
});